import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const EmptyDataIcon1 = () => (
  <ImageIcon src={Images.EmptyData1} alt="empty-data/" />
);

export default EmptyDataIcon1;
